/* eslint-disable camelcase */
import React, { createContext, useEffect, useState } from 'react'
import api from '../services/api'

interface BaseDataProps {
  id: string
  base: string
  outpost: string
  address: {
    address: string
    zipcode: string
    burgh: string
    city: string
    state: string
    latitude: number
    longitude: number
  }
}

interface INewAlert {
  id_base: string
  id_employee: string
  get_location: boolean
  alert_interval: number
}

interface IAlwaysAlert {
  baseList?: BaseDataProps[] | null
  baseOptions?: { id: string; value: string }[] | null
  setNewAlert: React.Dispatch<React.SetStateAction<BaseDataProps[] | null>>
  handleCreateAlert: (data: INewAlert) => void
  formatedData: (data: string) => string
}

export const AlwaysAlertContext = createContext<IAlwaysAlert>()

const AlwaysAlertProvider = (props) => {
  const [baseList, setBaseList] = useState<BaseDataProps[] | null>(null)
  const idUser = localStorage.getItem('id_user')
  const idBase = localStorage.getItem('id_base')
  const [newAlert, setNewAlert] = useState<INewAlert>({
    id_base: '',
    id_employee: '',
    get_location: true,
    alert_interval: 0,
  })

  const baseOptions = baseList?.map((item) => {
    const id = item.id
    const value = item.base

    return { id, value }
  })

  const formatedData = (data) => {
    const date = data
    if (!date) {
      return ''
    }

    const fullDate = new Date(date)
    const hours = String(fullDate.getUTCHours()).padStart(2, '0')
    const minutes = String(fullDate.getUTCMinutes()).padStart(2, '0')

    return `${hours}:${minutes}`
  }

  useEffect(() => {
    api
      .get('/v1/dashboard/base/list')
      .then((res) => {
        setBaseList(res.data)
      })
      .catch((err) => {
        console.log(err)
      })
  }, [])

  const handleCreateAlert = ({
    id_base,
    id_employee,
    alert_interval,
    get_location,
  }: INewAlert) => {
    try {
      api.post('/v1/always-alert/create', {
        id_base,
        id_employee,
        alert_interval,
        get_location,
      })
    } catch (err) {
      console.error('Erro ao enviar dados:', err.response.data)
      if (err.response && err.response.data) {
        console.error('Server error message:', err.response.data)
      }
    }
  }

  return (
    <AlwaysAlertContext.Provider
      value={{
        baseList,
        baseOptions,
        setNewAlert,
        handleCreateAlert,
        formatedData,
      }}
    >
      {props.children}
    </AlwaysAlertContext.Provider>
  )
}

export default AlwaysAlertProvider
